import { useState } from 'react';
import { FiGrid, FiUsers, FiClock, FiPackage, FiLogOut, FiMenu, FiX,FiLock, FiDollarSign } from 'react-icons/fi';
import Overview from '../components/Overview';
import Employees from '../components/Employees';
import Attendance from '../components/Attendance';
import Inventory from '../components/Inventory';
import Devices from '../components/Devices';
import MyPin from '../components/MyPin';
import Ledger from '../components/Ledger';
const TABS = [
  { id: 'overview',   label: 'Overview',   icon: FiGrid,        roles: ['OWNER', 'MANAGER'] },
  { id: 'employees',  label: 'Employees',  icon: FiUsers,       roles: ['OWNER', 'MANAGER'] },
  { id: 'attendance', label: 'Attendance', icon: FiClock,       roles: ['OWNER', 'MANAGER'] },
  { id: 'inventory',  label: 'Inventory',  icon: FiPackage,     roles: ['OWNER', 'MANAGER'] },
  { id: 'ledger',     label: 'Ledger',     icon: FiDollarSign,  roles: ['OWNER', 'MANAGER'] },
  { id: 'devices',    label: 'Devices',    icon: FiX,           roles: ['OWNER', 'MANAGER'] },
  { id: 'my-pin',     label: 'My PIN',     icon: FiLock,        roles: ['OWNER', 'MANAGER', 'EMPLOYEE'] },
];

export default function Dashboard({ token, user, onLogout }) {
  const [tab, setTab] = useState('overview');
  const [menuOpen, setMenuOpen] = useState(false);

  const visibleTabs = TABS.filter(t => t.roles.includes(user.role));
  const active = visibleTabs.find(t => t.id === tab) || visibleTabs[0];

  const renderTab = () => {
    switch (active.id) {
      case 'overview':   return <Overview token={token} user={user} />;
      case 'employees':  return <Employees token={token} user={user} />;
      case 'attendance': return <Attendance token={token} user={user} />;
      case 'inventory':  return <Inventory token={token} user={user} />;
      case 'ledger':     return <Ledger token={token} user={user} />;
      case 'devices':    return <Devices token={token} user={user} />;
      case 'my-pin':     return <MyPin token={token} user={user} />;
      default:           return null;
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      {/* Header */}
      <header className="bg-white border-b border-slate-200 px-4 sm:px-6 py-3 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <button className="sm:hidden text-slate-500" onClick={() => setMenuOpen(v => !v)}>
            {menuOpen ? <FiX size={20} /> : <FiMenu size={20} />}
          </button>
          <div>
            <span className="font-bold text-slate-800 text-sm sm:text-base">
              {user.business_name || 'Business Portal'}
            </span>
            <span className="ml-2 text-xs text-slate-400 hidden sm:inline">{user.role}</span>
          </div>
        </div>
        <button onClick={onLogout} className="flex items-center gap-1.5 text-slate-500 hover:text-red-500 text-sm transition-colors">
          <FiLogOut size={16} /> <span className="hidden sm:inline">Sign out</span>
        </button>
      </header>

      <div className="flex flex-1">
        {/* Sidebar — desktop */}
        <aside className="hidden sm:flex flex-col w-48 bg-white border-r border-slate-200 p-3 gap-1">
          {visibleTabs.map(t => (
            <button
              key={t.id}
              onClick={() => setTab(t.id)}
              className={`flex items-center gap-2.5 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors text-left ${
                active.id === t.id
                  ? 'bg-blue-50 text-blue-700'
                  : 'text-slate-600 hover:bg-slate-50'
              }`}
            >
              <t.icon size={16} />
              {t.label}
            </button>
          ))}
        </aside>

        {/* Mobile nav */}
        {menuOpen && (
          <div className="sm:hidden absolute top-14 left-0 right-0 bg-white border-b border-slate-200 z-20 p-3 flex flex-col gap-1">
            {visibleTabs.map(t => (
              <button
                key={t.id}
                onClick={() => { setTab(t.id); setMenuOpen(false); }}
                className={`flex items-center gap-2.5 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors text-left ${
                  active.id === t.id ? 'bg-blue-50 text-blue-700' : 'text-slate-600'
                }`}
              >
                <t.icon size={16} />
                {t.label}
              </button>
            ))}
          </div>
        )}

        {/* Main content */}
        <main className="flex-1 overflow-auto">
          {renderTab()}
        </main>
      </div>
    </div>
  );
}
